import React from 'react';
import { StyledRedSquare } from './RedSquare.styles';
import { RedSquareProps } from './RedSquare.types';

const RedSquare: React.FC<RedSquareProps> = React.memo(({ size = 'medium', customSize }) => {
  return <StyledRedSquare size={size} customSize={customSize} />;
});

RedSquare.displayName = 'RedSquare';

export default RedSquare;
